/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { getPMData } from 'common/services/pm.service';
import { formatPmEntitiesByName } from './filters.formatter';
import { useSelector } from 'react-redux';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import { SENSOR_STATES } from '@linearb/linjs-common';
import { FILTER_TYPES, filterFormatter } from 'common/constants/filters';

const usePmFilters = () => {
  const pmSensor = useSelector(pmIntegrationSelector);
  const isAuthorized = pmSensor?.state === SENSOR_STATES.ok;
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [labels, setLabels] = useState([]);
  const [issueTypes, setIssueTypes] = useState([]);

  const formattedCustomFields =
    filterFormatter[FILTER_TYPES.FIELD](customFields);
  const formattedLabels = formatPmEntitiesByName(labels);
  const formattedIssueTypes = formatPmEntitiesByName(issueTypes);

  const fetchData = async () => {
    setIsLoadingFilters(true);
    const pmData = await getPMData(isAuthorized, pmSensor?.sensor_id);
    setCustomFields(pmData.customFields);
    setLabels(pmData.labels);
    setIssueTypes(pmData.issueTypes);
    setIsLoadingFilters(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    issueTypes: formattedIssueTypes,
    labels: formattedLabels,
    customFields: formattedCustomFields,
    isLoadingFilters
  };
};

export default usePmFilters;
